export default {
  areaList: [],
  areaTematicaList: [],
  regioneList: [],
  areaRiservataEnumList: [],
  trainingCourseTypesList: [],
}
